import Vue from 'vue'
import Router from 'vue-router'
import { createRouterConfig } from './lib/createRouterConfig'

import layout from './components/Layout'
import { noLayoutRoutes, rootRoutes } from './views/routes'

Vue.use(Router)

export default new Router(
  createRouterConfig(layout, rootRoutes, noLayoutRoutes)
)
